export class LokalizacjaUszkodzenia {
  public static readonly POKOJ = new LokalizacjaUszkodzenia('pokoj', 'Pokój', '19_11', 'assets/images/pomieszczenia/04_Pokoj_21_10_07.png');
  public static readonly KUCHNIA = new LokalizacjaUszkodzenia('kuchnia', 'Kuchnia', '15_4', 'assets/images/pomieszczenia/05_Kuchnia_21_10_07.png');
  public static readonly LAZIENKA = new LokalizacjaUszkodzenia('lazienka', 'Łazienka', '19_14', 'assets/images/pomieszczenia/06_Lazienka_21_10_07.png');
  public static readonly PRZEDPOKOJ = new LokalizacjaUszkodzenia('przedpokoj', 'Przedpokój', '19_19 ', 'assets/images/pomieszczenia/07_Przedpokoj_21_10_07.png');
  public static readonly INNE_POMIESZCZENIE = new LokalizacjaUszkodzenia('innePomieszczenie', 'Inne pomieszczenie', '20_4 ', 'assets/images/pomieszczenia/09_Inne_pomieszczenie_21_10_07.png');
  public static readonly DACH = new LokalizacjaUszkodzenia('dach', 'Dach', '', 'assets/images/elementy/10_Dom_jednorodzinny_Elementy_dachu_21_11_26.png');
  public static readonly ELEWACJA = new LokalizacjaUszkodzenia('elewacja', 'Elewacja', '', 'assets/images/elementy/OMCS_Elewacja.svg');
  public static readonly RYNNY_RURY = new LokalizacjaUszkodzenia('rynnyRury', 'Rynny i rury spustowe', '', 'assets/images/elementy/23_Budynek_niemieszkalny_Elementy_zewnetrzne.png');
  public static readonly DASZEK = new LokalizacjaUszkodzenia('daszek', 'Zadaszenie nad tarasem lub wejściem', '', 'assets/images/elementy/26_Budynek_firmowy_Elementy_zewnetrzne.png');
  public static readonly POMIESZCZENIA_DOM_JEDNORODZINNY = new LokalizacjaUszkodzenia('pomieszczenia', 'Pomieszczenia', '', undefined);
  public static readonly POMIESZCZENIE_GOSPODARCZE = new LokalizacjaUszkodzenia('pomieszczenieGospodarcze', 'Pomieszczenie gospodarcze', '', 'assets/images/pomieszczenia/08_Pomieszczenie_gospodarcze_21_10_07.png');
  public static readonly POMIESZCZENIE_GOSPODARCZE_MIESZKANIE = new LokalizacjaUszkodzenia('pomieszczenieGospodarczeMieszkanieIDom', 'Pomieszczenie gospodarcze', '15_15', 'assets/images/pomieszczenia/08_Pomieszczenie_gospodarcze_21_10_07.png');
  public static readonly POMIESZCZENIE_GARAZOWE = new LokalizacjaUszkodzenia('pomieszczenieGarazowe', 'Pomieszczenie garażowe', '', 'assets/images/pomieszczenia/19_Pomieszczenie_garaz_21_10_07.png');
  public static readonly POMIESZCZENIE_GARAZOWE_DOM = new LokalizacjaUszkodzenia('pomieszczenieGarazoweDom', 'Garaż', '20_29', 'assets/images/pomieszczenia/19_Pomieszczenie_garaz_21_10_07.png');
  public static readonly PRZEDMIOTY_SZKLANE = new LokalizacjaUszkodzenia('przedmiotySzklane', 'Przedmioty od stłuczenia', '', 'assets/images/elementy/OMCS_przedmioty_od_stłuczenia.svg');
  public static readonly OGRODZENIA = new LokalizacjaUszkodzenia('ogrodzenia', 'Ogrodzenia', '', 'assets/images/elementy/OMCS_brama_ogrodzenia.svg');
  public static readonly OSZKLENIA_WITRAZE = new LokalizacjaUszkodzenia('oszkleniaWitraze', 'Oszklenia, witraże, lustra, wykładziny', '', '');
  public static readonly INNE = new LokalizacjaUszkodzenia('inne', 'Inne', '', '');
  public static readonly PIWNICA = new LokalizacjaUszkodzenia('piwnica', 'Piwnica', '15_23', 'assets/images/pomieszczenia/08_Pomieszczenie_gospodarcze.png');
  public static readonly lokalizacje = [
    LokalizacjaUszkodzenia.POKOJ,
    LokalizacjaUszkodzenia.KUCHNIA,
    LokalizacjaUszkodzenia.LAZIENKA,
    LokalizacjaUszkodzenia.PRZEDPOKOJ,
    LokalizacjaUszkodzenia.INNE_POMIESZCZENIE,
    LokalizacjaUszkodzenia.DACH,
    LokalizacjaUszkodzenia.ELEWACJA,
    LokalizacjaUszkodzenia.RYNNY_RURY,
    LokalizacjaUszkodzenia.DASZEK,
    LokalizacjaUszkodzenia.POMIESZCZENIE_GOSPODARCZE,
    LokalizacjaUszkodzenia.POMIESZCZENIE_GOSPODARCZE_MIESZKANIE,
    LokalizacjaUszkodzenia.POMIESZCZENIE_GARAZOWE,
    LokalizacjaUszkodzenia.POMIESZCZENIE_GARAZOWE_DOM,
    LokalizacjaUszkodzenia.PRZEDMIOTY_SZKLANE,
    LokalizacjaUszkodzenia.OGRODZENIA,
    LokalizacjaUszkodzenia.INNE,
    LokalizacjaUszkodzenia.PIWNICA
  ]
  // the names of the below fields are stricly related to ButtonModel - needs refactoring in the next steps
  constructor(readonly name: string,
              readonly label: string,
              readonly imageSource: string,
              readonly obraz: string | undefined) {
  }

  static pobierz(nazwa: string): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.lokalizacje.find(pomieszczenie => pomieszczenie.name === nazwa) as LokalizacjaUszkodzenia
  }

  static pobierzPomieszczenia(): LokalizacjaUszkodzenia[] {
    return [
      LokalizacjaUszkodzenia.POKOJ,
      LokalizacjaUszkodzenia.KUCHNIA,
      LokalizacjaUszkodzenia.LAZIENKA,
      LokalizacjaUszkodzenia.PRZEDPOKOJ,
      LokalizacjaUszkodzenia.POMIESZCZENIE_GOSPODARCZE_MIESZKANIE,
      LokalizacjaUszkodzenia.INNE_POMIESZCZENIE,
      LokalizacjaUszkodzenia.POMIESZCZENIE_GARAZOWE_DOM,
      LokalizacjaUszkodzenia.PIWNICA]
  }
}

export const lokalizacjeUszkodzenMieszkanie = [
  LokalizacjaUszkodzenia.POKOJ,
  LokalizacjaUszkodzenia.KUCHNIA,
  LokalizacjaUszkodzenia.PRZEDPOKOJ,
  LokalizacjaUszkodzenia.LAZIENKA,
  LokalizacjaUszkodzenia.POMIESZCZENIE_GOSPODARCZE_MIESZKANIE,
  LokalizacjaUszkodzenia.INNE_POMIESZCZENIE,
  LokalizacjaUszkodzenia.PIWNICA];

export const lokalizacjeUszkodzenDomJednorodzinny = [
  LokalizacjaUszkodzenia.POMIESZCZENIA_DOM_JEDNORODZINNY,
  LokalizacjaUszkodzenia.ELEWACJA,
  LokalizacjaUszkodzenia.DACH,
  LokalizacjaUszkodzenia.RYNNY_RURY,
  LokalizacjaUszkodzenia.DASZEK];

export const lokalizacjeUszkodzenBudynekNiemieszkalny = [
  LokalizacjaUszkodzenia.POMIESZCZENIE_GOSPODARCZE,
  LokalizacjaUszkodzenia.ELEWACJA,
  LokalizacjaUszkodzenia.DACH,
  LokalizacjaUszkodzenia.RYNNY_RURY,
  LokalizacjaUszkodzenia.DASZEK];

export const lokalizacjeUszkodzenGaraz = [
  LokalizacjaUszkodzenia.POMIESZCZENIE_GARAZOWE,
  LokalizacjaUszkodzenia.ELEWACJA,
  LokalizacjaUszkodzenia.DACH,
  LokalizacjaUszkodzenia.RYNNY_RURY,
  LokalizacjaUszkodzenia.DASZEK];

export const lokalizacjeUszkodzenPrzedmiotySzklane = [
  LokalizacjaUszkodzenia.PRZEDMIOTY_SZKLANE]

export const lokalizacjeUszkodzenBudowle = [
  LokalizacjaUszkodzenia.OGRODZENIA]

export const lokalizacjeUszkodzenOszkleniaWitraze = [
  LokalizacjaUszkodzenia.OSZKLENIA_WITRAZE]

export const lokalizacjeUszkodzenInne = [
  LokalizacjaUszkodzenia.INNE]
